// Columns the backend can sort on. The backend's sort_field param expects
// these exact names, matching the frontend header keys 1:1 — no translation.
const BACKEND_SORTABLE_FIELDS = ["run_id", "start_time", "end_time"];

export const requiresBackendSort = (key: string) =>
  BACKEND_SORTABLE_FIELDS.includes(key);

export const getSortFieldMapping = (key: string) => key;

// Given the { keytoSort, direction } sort state, returns the params to
// forward to fetchMonitoringProcessLogs so an active backend sort survives
// filter changes, refreshes, and pagination — not just the initial sort click.
export const getBackendSortParams = (sort: {
  keytoSort?: string;
  direction?: string;
}): [string?, ("ASC" | "DESC")?] => {
  if (sort?.keytoSort && sort?.direction && requiresBackendSort(sort.keytoSort)) {
    return [
      getSortFieldMapping(sort.keytoSort),
      sort.direction.toUpperCase() as "ASC" | "DESC",
    ];
  }
  return [undefined, undefined];
};
